import type { EventLite } from '~/models/events'
import type { Media } from '~/models/media'
import type { ShowcaseAdditionalQuestion } from '~/models/showcase-additional-questions'

export enum ShowcaseRequestsAvailability {
  Available = 'available',
  Forbidden = 'forbidden',
  Early = 'early',
  Late = 'late',
}

export interface ShowcaseLite {
  id: number
  event_id: number
  event: EventLite
  name: string
  slug: string
  poll_stage_id: number
  is_voting_open: boolean
  rating_scale: number
  form_until_date: string
  requests_start_date: string | null
  requests_end_date: string | null
}

export interface Showcase extends ShowcaseLite {
  poll_id: number
  votes: [] | null
  requests_availability: ShowcaseRequestsAvailability
  form_title: string
  form_main_color: string
  form_logo: Media | null
  form_slogan: Media | null
  form_description: string
  is_show_form_participation_block: boolean
  form_participation_block_color: string
  additional_questions: ShowcaseAdditionalQuestion[]
}
